
import React, { useState } from 'react'
import { swalMessages } from 'src/constants'
import { useHistory } from 'react-router-dom'
import UsersCreator from 'src/pages/AdminControl/UsersAdmin/UsersCreator'
import adminInventoryService from 'src/services/adminInventoryService'
import * as paths from 'src/routes/paths'
import swal from 'sweetalert'

function defaultFormValue() {
  return {
    correo: '',
    nombre: '',
    apellido: '',
    clave: '',
  }
}

const CreateInventoryUserContainer = () => {
  const [error, setError] = useState({
    error: false,
    success: false,
  })
  const [user, setUser] = useState(defaultFormValue())
  const history = useHistory()

  const handleCreate = async (event) => {
    event.preventDefault()
    const response = await adminInventoryService.createUser(user)
    if (response.id === 0) {
      swal(swalMessages.REPEAT_MESSAGE_ERROR)
    } else {
      swal(swalMessages.SUCCESSFUL_MESSAGE)
      history.push(paths.ADMIN_USERS_INVENTORY)
    }
  }

  const onChange = (event, type) => {
    setUser({ ...user, [type]: event.target.value })
    if (user.clave.length < 8) {
      setError({ error: true, success: false })
    } else if (user.clave.length >= 8) {
      setError({ error: false, success: true })
    }
  }

  return (
    <UsersCreator
      onChange={onChange}
      user={user}
      error={error}
      onCreate={handleCreate}
    />
  )
}

export default CreateInventoryUserContainer
